
import GoogleMapReact from 'google-map-react';
import { Component } from 'react';
import { googleMapsApiKey } from '../../../static/google-map-key';

export type MapProps = {
  lat: number,
  lng: number
}

type MapsProps = {
  array?: MapProps[],
  default?: MapProps,
  onMarkerClick?: any;
  centerMap?: MapProps;
  positionUser?: MapProps;
  pharmacySelected?: MapProps;
  zoom?: number;
  onPropChange?: boolean;
}

  class MapTabComponent extends Component<MapsProps,{}> {

      isMarkerPharmacySelected = (latMarker: number,lngMarker: number): boolean => {
        if(this.props.pharmacySelected) {
          return (
            this.props.pharmacySelected.lat === latMarker &&
            this.props.pharmacySelected.lng === lngMarker
          )
        }
        else {
          return false;
        }
      }

      renderMarkers = (map:any, maps:any) => {

        if(this.props?.array && this.props?.array.length > 0){
          let listMarkers = this.props.array?.map((x,i) => {
            //if(i===0) {
         //   }
            let markerPharmacy = new maps.Marker({
              position: x,
              map,
              icon: {
                url: this.isMarkerPharmacySelected(x.lat,x.lng) 
                  ? 
                  "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png" 
                  :
                  "http://maps.google.com/mapfiles/ms/icons/red-dot.png"
              }
              });


              return markerPharmacy;
          });
          
            listMarkers.forEach((m,i) => {
              
              m.addListener("click", () => {
                if(this.props?.array &&  this.props?.array.length > 0){
                  this.props.onMarkerClick(this.props.array[i].lat,this.props.array[i].lng)
                }
              })
            })

            if(this.props.positionUser) {
              let marker = new maps.Marker({
                position: this.props.positionUser,
                map,
                icon: {
                  url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
                }
              });
              listMarkers.push(marker);
            }
        
            return listMarkers;

        } else {
          let marker = new maps.Marker({
          position: this.props.default,
          map,
          });
          return marker;
        }
        
       };

      render(){
        return (
          <div className="map-tab-container" style={{position:'relative', height: '20vh'}}>
            <div className='flex flex-column justify-content-center align-items-center position-center' style={{ fontSize: '2rem', position:'absolute'}}>
              <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem'}} ></i>
            </div>


              <div className="border-maps position-center" style={{ position:'absolute' }}>
                  <GoogleMapReact
                      bootstrapURLKeys={{ key: googleMapsApiKey }}
                     // defaultCenter={this.props.default}
                      center={ this.props.centerMap ? this.props.centerMap : this.props.default}
                      defaultZoom={17}
                      zoom={this.props.zoom ? this.props.zoom : undefined}
                      onGoogleApiLoaded={({ map, maps }) => this.renderMarkers(map, maps)}
                      yesIWantToUseGoogleMapApiInternals={true}
                      >

                  </GoogleMapReact>

              </div>
          </div>

        );
      }
}

export default MapTabComponent;